module.exports = __webpack_public_path__ + "img/Vector.36c8e428.svg";